import { render, staticRenderFns } from "./header-secondary.vue?vue&type=template&id=b288012e&scoped=true"
import script from "./header-secondary.vue?vue&type=script&lang=js"
export * from "./header-secondary.vue?vue&type=script&lang=js"
import style0 from "./header-secondary.vue?vue&type=style&index=0&id=b288012e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b288012e",
  null
  
)

export default component.exports